import React from 'react'
import { 
  Delimiter,
  InnerContainer,
  LogoHolder,
  StyledMintComponent,
  Trailer,
  TrailerControls,
  TrailerContainer
} from "./Mint.styled"
import { PlayVideo, Megalogo } from '../';
import { default as MintActionFigures } from "./MintActionFigures"
import VerticalTicker from './MintTicker'
import MintFigures from './MinFigures'
import MintEquipment from './MintEquipment'
import FooterMap from './FooterMap'
import { Panel, PanelHolder, PanelImage } from './MintActionFigures.styled'
import useIsMobile from '../../hooks/useIsMobile';

export default function MintComponent({ intersectionRef, anchorRef }) {
  const isMobile = useIsMobile();
  return (
    <StyledMintComponent>
	  {/*<MintActionFigures />*/}
      <InnerContainer>
        <PanelHolder>
          <Delimiter />
          {isMobile &&
            <Panel>
              <PanelImage src="/assets/panel_top.png"/>
            </Panel>
          }
        </PanelHolder>
        {!isMobile && <>
          <TrailerContainer>
            <Trailer src="/assets/basejump_homepage_2024_2.webm" autoPlay loop muted={true}/>
            <TrailerControls>
              <PlayVideo/>
            </TrailerControls>
            <LogoHolder $isMobile={isMobile}>
              <Megalogo onlyMid/>
            </LogoHolder>
            <div ref={anchorRef} style={{position: 'absolute', bottom: '0', width: '100%'}}>
              <div ref={intersectionRef} style={{width: '100%'}}/>
            </div>
          </TrailerContainer>
          <Delimiter />
          <Panel>
            <PanelImage src="/assets/panel_top.png"/>
          </Panel>
          <VerticalTicker />
	</>}
        <MintFigures />
        <MintEquipment />
        <PanelHolder>
          <Panel>
            <PanelImage src="/assets/panel_bottom.png"/>
          </Panel>
          <Delimiter />
        </PanelHolder>
      </InnerContainer>
      
      {/*<FooterMap />*/}
    </StyledMintComponent>
  )
}
